import { Component, ElementRef, HostListener, inject, input, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { NavItem } from '@core/navigation/nav.config';
import { cn } from '@shared/utils/class-names';

@Component({
  selector: 'app-desktop-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslocoPipe, LocalizedRouterLinkPipe],
  templateUrl: './desktop-nav.component.html',
})
export class DesktopNavComponent {
  readonly items = input<NavItem[]>([]);
  readonly isDark = input(false);

  private readonly host = inject(ElementRef<HTMLElement>);

  protected readonly cn = cn;
  protected readonly openMenu = signal<string | null>(null);

  protected toggleMenu(labelKey: string): void {
    this.openMenu.update((current) => (current === labelKey ? null : labelKey));
  }

  protected openMenuOnHover(labelKey: string): void {
    this.openMenu.set(labelKey);
  }

  protected closeMenus(): void {
    this.openMenu.set(null);
  }

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.closeMenus();
    }
  }
}
